"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sidebar_module_scss_1 = __importDefault(require("./sidebar.module.scss"));
const SidebarHeader = ({ tenantName }) => ((0, jsx_runtime_1.jsx)("div", { className: sidebar_module_scss_1.default.sidebarHeader, children: (0, jsx_runtime_1.jsx)("span", { className: sidebar_module_scss_1.default.sidebarLogo, children: (0, jsx_runtime_1.jsx)("span", { className: sidebar_module_scss_1.default.sidebarLogoText, children: (0, jsx_runtime_1.jsx)("span", { className: 'font-montserratMedium', children: tenantName ?? '' }) }) }) }));
exports.SidebarHeader = SidebarHeader;
